import { render, staticRenderFns } from "./NewsletterEmail.vue?vue&type=template&id=39f94e23&scoped=true&"
import script from "./NewsletterEmail.vue?vue&type=script&lang=js&"
export * from "./NewsletterEmail.vue?vue&type=script&lang=js&"
import style0 from "./NewsletterEmail.vue?vue&type=style&index=0&id=39f94e23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f94e23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemAction,VListItemTitle})
